const INPUT_FIELD_TYPES = ['checkbox', 'date', 'datetime-local', 'email', 'month', 'number', 'password', 'radio', 'range', 'search', 'tel', 'text', 'time', 'url', 'week'];

export { INPUT_FIELD_TYPES };
